import { connect } from 'react-redux'
import TextLinkListItem from './component'

import NavigationHelper from 'layers/navigation/navigationHelper'

export default connect(
  null,
  NavigationHelper.mapDispatchToProps,
)(TextLinkListItem)
